import { Typography, Box, Grid } from "@mui/material";

const CAVPSection = ({ productForm }: { productForm: any }) => {
  return (
    <Box className="mb-4">
      {/* WARN: Custom styling from pre standardization! */}
      {/* TODO: Standardize when you come across this!  */}
      <Typography variant="body1" className="mb-2">
        CAVP CERTIFICATE
      </Typography>

      <div className="border p-3 rounded">
        {/* WARN: Custom styling from pre standardization! */}
        {/* TODO: Standardize when you come across this!  */}
        <Typography
          variant="body1"
          className="mb-3"
          sx={{ color: "text.secondary" }}
        >
          Select if the product requires a CAVP Certificate, if so, enter the
          estimated completion date.
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <productForm.AppField
                name="nist.nist_required"
                listeners={{
                  onChange: ({ value }: { value: boolean }) => {
                    !value && productForm.resetField("nist.nist_completion");
                  },
                }}
              >
                {(nistRequiredField: any) => (
                  <>
                    <nistRequiredField.SingleCheckbox label="CAVP Certificate Required?" />
                    {nistRequiredField.state.value && (
                      <productForm.AppField name="nist.nist_completion">
                        {(field: any) => (
                          <field.TextInput
                            label="Estimated CAVP Certificate completed date:"
                            type="date"
                            required
                            slotProps={{
                              inputLabel: {
                                shrink: true,
                              },
                            }}
                          />
                        )}
                      </productForm.AppField>
                    )}
                  </>
                )}
              </productForm.AppField>
            </Box>
          </Grid>
        </Grid>
      </div>
    </Box>
  );
};

export default CAVPSection;
